<template>
    <div :class="[{'theme-black': type==='black'}, {'theme-orange': type==='orange'},'progress-wrap','flex-ac']">
        <div v-if="type === 'orange'">
            <img class="icon" src="../../../../static/imgs/red1.png" alt="" v-if="index === 1">
            <img class="icon" src="../../../../static/imgs/red2.png" alt="" v-else-if="index === 2">
            <img class="icon" src="../../../../static/imgs/red3.png" alt="" v-else-if="index === 3">
            <span class="idx gray99 fs18" v-else>{{ index }}</span>
        </div>
        <div v-if="type === 'black'">
            <img class="icon" src="../../../../static/imgs/black1.png" alt="" v-if="index === 1">
            <img class="icon" src="../../../../static/imgs/black2.png" alt="" v-else-if="index === 2">
            <img class="icon" src="../../../../static/imgs/black3.png" alt="" v-else-if="index === 3">
            <span class="idx gray99 fs18" v-else>{{ index }}</span>
        </div>
        <div class="title fs18 f6">{{title}}</div>
        <div class="total-box">
            <div class="val" :style="{'width': value < 0 ? 0 : value > 100 ? '100%' : value + '%'}"></div>
        </div>
        <div class="rate">{{value}}%</div>
    </div>
</template>

<script>
export default {
    props:{
        type: {
            type: String,
            default: 'orange'
        },
        index:{
            type: Number,
            default: 1
        },
        value:{
            type: Number,
            default: 0
        },
        title:{
            type: String,
            default: ''
        },
    }
};
</script>
<style scoped lang="scss">
.progress-wrap{
    width: 100%;
    &.theme-black{
        .total-box{
            background-color: #EDF1F7;
        }
        .title,.rate{
            color: #333;
        }
        .val{
            background: linear-gradient(90deg, #333333 0%, #B3B3B3 100%);
        }
    }
    &.theme-orange{
        .total-box{
            background-color: #EDF1F7;
        }
        .title,.rate{
            color: #E69D37;
        }
        .val{
            background: linear-gradient(-90deg, #E69D37 0%, #F2B259 100%);
        }
    }
}
.total-box{
    width: 290px;
    overflow: hidden;
}
.total-box,.val{
    height: 8px;
    border-radius: 4px;
}
.title{
    width: 84px;
}
.rate{
    width: 82px;
    text-align: right;
}
.icon{
    width: 44px;
    height: 44px;
    margin-right: 16px;
}
.idx{
    width: 44px;
    text-align: center;
    margin-right: 16px;
}
</style>
